<template>
    <div>
        <div class="ingresos">
            <h5>Ingresos</h5>
            <div class="table-responsive" v-if="entries.length">
                <table class="table table-sm table-hover table-bordered table-striped">
                    <thead class="thead-orange">
                        <tr class="x-d-flex">
                            <th>Fecha Ingreso</th>
                            <th>Estructura</th>
                            <th>Destino</th>
                            <th>Persona</th>
                            <th>Tipo de visita</th>       
                            <th>Medio de visita</th>
                            <th>Fecha de salida</th>
                            <th>Duración</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr v-for="entry in entries" class="x-d-flex">
                            <td>{{ entry.created_at }}</td>
                            <td>{{ entry.structure.name }}</td>
                            <td>{{ entry.destination.name }}</td>
                            <td><div v-if="entry.visited_person">{{ entry.visited_person.name }}</div></td>
                            <td>{{ entry.visitor_type.name }}</td>
                            <td><div v-if="!entry.vehicle_entry_id">Ingreso peatonal</div><div v-if="entry.vehicle_entry_id">Ingreso en vehículo</div></td>                
                            <td><div v-if="entry.departure">{{entry.departure.created_at}}</div></td>
                            <td>{{ !!entry.duration?moment.duration(entry.duration, 'minutes').humanize():'Sin salida' }} </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="alert alert-danger" v-if="!entries.length">No se han registrado ingresos</div>
        </div>
    </div>
        
</template>
<script>
import PeopleRepository from '../../../repositories/people.repository.js';
export default {
    props: {
        person: {
            type: Object,
            required: true
        },
        clientId: {
            type: Number,
            required: true
        }

    },

    data(){
        return{
            entries: []
        };
    },

    methods: {
        loadEntries(){
            const pr = Object.assign({}, PeopleRepository);
            pr
                .getPersonEntries(this.clientId, this.person.document)
                .then(data => (this.entries = data))
                .catch(error => (toastr('Error al cargar las entradas de la persona')));
        },
        cleanFields(){
            this.entries = [];
        }
    },

    created(){
        this.loadEntries();
        this.$bus.$on('person-entry-history.clean', this.cleanFields);  
    }
    
}
</script>

